import { render, staticRenderFns } from "./TfBalance.vue?vue&type=template&id=e4a11c78&scoped=true&"
import script from "./TfBalance.vue?vue&type=script&lang=js&"
export * from "./TfBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a11c78",
  null
  
)

export default component.exports